import { UptimeMarketPlace } from '@uptime/uptime-component';
import React from 'react';
import Avatar from '@mui/material/Avatar';
import { StyledAvatar } from './UserAvatar.style';
import { getAvatarName, stringAvatar } from 'utils/function';

export interface IUserAvatarProps {
  userData?: any;
  imgUser?: any;
  showUserName?: boolean;
}

const UserAvatar: React.FC<IUserAvatarProps> = props => {
  const { userData, imgUser, showUserName } = props;

  return (
    <>
      {!imgUser ? (
        <StyledAvatar>
          <Avatar {...stringAvatar(userData?.name, 32)}/>
        </StyledAvatar>
      ) : (
        <Avatar
          alt={`${getAvatarName(userData?.name)}`}
          src={imgUser}
          sx={{width: 32, height: 32}}
          slotProps={{
            img: {
              title: `${getAvatarName(userData?.name)}`,
            }
          }}
        />
      )}

      {showUserName && (
        <UptimeMarketPlace.Typography variant="h6" color="white" marginLeft="12px">
          {userData?.name}
        </UptimeMarketPlace.Typography>
      )}
    </>
  );
};

export default UserAvatar;
